import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

// Matches the contexts previously defined in proxy.conf.js
const API_PREFIXES = [
  '/auth',
  '/run',
  '/tasks',
  '/workflows',
  '/guard',
  '/monitors',
  '/notifications',
  '/billing',
  '/niches',
  '/users'
];

export const apiUrlInterceptorFn: HttpInterceptorFn = (req, next) => {
  // Only intercept known API routes to avoid breaking static asset requests
  const isApiRequest = API_PREFIXES.some(prefix => req.url.startsWith(prefix));
  
  if (isApiRequest) {
    // Ensure no double slashes if environment.apiBaseUrl ends with '/'
    const baseUrl = environment.apiBaseUrl.endsWith('/') 
      ? environment.apiBaseUrl.slice(0, -1) 
      : environment.apiBaseUrl;
      
    // This clone preserves all original headers (including Sentry's sentry-trace / baggage)
    const apiReq = req.clone({
      url: `${baseUrl}${req.url}`
    });
    return next(apiReq);
  }
  
  return next(req);
};
